exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.file-finder-overlay[data-v-7679498a] {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 200;\n}\n.file-finder[data-v-7679498a] {\n  top: 10px;\n  left: 50%;\n  transform: translateX(-50%);\n}\n.diff-file-changes[data-v-7679498a] {\n  top: 50px;\n  max-height: 327px;\n}\n", ""]);

// exports
